var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader-text"},[_c('p',[_vm._v(_vm._s(_vm.upperText))]),_c('p',[_vm._v(_vm._s(_vm.lowerText))]),_c('div',[_c('common-icon',{class:_vm.iconClass,attrs:{"name":_vm.icon,"size":_vm.getIconSize}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }